module.exports = __webpack_public_path__ + "img/espa.602e36c4.png";